import { sortArrayBy } from '@domain-group/javascript-utils'

import type { ProviderPriceListItemModel } from '@models/types'

import type { EntitiesState } from '@redux/entities'

type FilterPriceListItemsByPriceListAndProductParams = {
  providerPriceListItem: ProviderPriceListItemModel | { id?: number },
  providerPriceListItemOptions: EntitiesState['providerPriceListItemOptions'],
}

const filterPriceListItemOptionsByItem = (params: FilterPriceListItemsByPriceListAndProductParams) => {
  const { providerPriceListItem, providerPriceListItemOptions } = params

  if (!providerPriceListItem?.id){
    return []
  }

  const filtered = Object.values(providerPriceListItemOptions)
    .filter((providerPriceListItemOption) => {
      const { hidden, provider_price_list_item_id } = providerPriceListItemOption

      return !hidden
        && providerPriceListItem.id === provider_price_list_item_id
    })

  const sorted = sortArrayBy(
    filtered,
    'asc',
    item => ('sort' in item ? item.sort : item.title),
  )

  return sorted
}

export default filterPriceListItemOptionsByItem
